import { Component, Input, OnInit } from '@angular/core';
import { ExerciseContainer } from '../../agenda/agenda.component';

@Component({
  selector: 'app-agenda-block-break',
  templateUrl: './agenda-block-break.component.html',
  styleUrls: ['./agenda-block-break.component.scss']
})
export class AgendaBlockBreakComponent implements OnInit {

  @Input() container: ExerciseContainer = null;

  constructor() { }

  ngOnInit(): void {
  }

}
